interface TittleProps {
    title: string
    className?: string
}

export const Tittle = ({ title, className }: TittleProps): JSX.Element => {
    return (
        <h1 className={`text-4xl text-primary font-bold  ${className}`}>
            {title}
        </h1>
    )
}
